<template>
  <div class="legal-page">
    <div class="legal-container">
      <nav class="legal-nav">
        <router-link
          v-for="doc in documents"
          :key="doc.slug"
          :to="`/${doc.slug}`"
          class="legal-nav-item"
          :class="{ active: doc.slug === slug }"
        >
          {{ doc.title }}
        </router-link>
      </nav>

      <div v-if="loading" class="legal-state">Carregando…</div>

      <div v-else-if="error" class="legal-state">
        {{ error }} — escreva para <a :href="`mailto:${dpoEmail}`">{{ dpoEmail }}</a>.
      </div>

      <article v-else class="legal-body">
        <span class="legal-version">Versão {{ document.version }}</span>
        <!--
          HTML vindo do backend, convertido de markdown versionado no repositório
          com escape ligado — não é conteúdo de usuário.
        -->
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="legal-content" v-html="document.content_html"></div>
      </article>
    </div>
  </div>
</template>

<script>
import { LegalDocumentService } from '@/services/api/PrivacyService'

/**
 * Termos, Política de Privacidade e Cookies também no backoffice.
 *
 * O texto e a versão são os mesmos do marketplace — vêm do backend —, então
 * professor, clube e influencer leem exatamente o que o aluno leu, sem uma
 * segunda cópia para sair de sincronia.
 */
export default {
  name: 'LegalDocument',
  data() {
    return {
      loading: true,
      error: null,
      document: { title: '', version: '', content_html: '' },
      documents: [],
      dpoEmail: 'privacidade@hubeesports.com'
    }
  },
  computed: {
    slug() {
      return this.$route.params.slug || this.$route.meta.slug
    }
  },
  watch: {
    slug: 'load'
  },
  mounted() {
    this.loadIndex()
    this.load()
  },
  methods: {
    service() {
      return LegalDocumentService.build()
    },
    async loadIndex() {
      try {
        const data = await this.service().documents()
        this.documents = data.documents || []
        this.dpoEmail = (data.dpo && data.dpo.email) || this.dpoEmail
      } catch (e) {
        this.documents = []
      }
    },
    async load() {
      this.loading = true
      this.error = null

      try {
        this.document = await this.service().document(this.slug)
      } catch (e) {
        this.error = 'Documento indisponível no momento'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.legal-page {
  background: #fff;
  min-height: 100vh;
  padding: 2rem 1rem 4rem;
}

.legal-container {
  max-width: 860px;
  margin: 0 auto;
}

.legal-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #ebe9f1;
  padding-bottom: 1rem;
}

.legal-nav-item {
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.875rem;
  color: #5e5873;
  background: #f8f8f8;

  &:hover { background: #ebe9f1; }
  &.active { background: #1d3531; color: #fff; }
}

.legal-state {
  padding: 3rem 0;
  text-align: center;
  color: #6e6b7b;
}

.legal-version {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 2rem;
  background: #E2E12E;
  color: #1d3531;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}

.legal-content {
  color: #5e5873;
  line-height: 1.7;

  ::v-deep {
    h1 { font-size: 1.9rem; margin: 0 0 1rem; color: #1d3531; }
    h2 {
      font-size: 1.3rem;
      margin: 2.25rem 0 0.75rem;
      color: #1d3531;
      padding-top: 1rem;
      border-top: 1px solid #f0eef4;
    }
    h3 { font-size: 1.05rem; margin: 1.5rem 0 0.5rem; color: #1d3531; }
    p { margin: 0 0 1rem; }
    ul, ol { margin: 0 0 1rem; padding-left: 1.5rem; }
    a { color: #1d7a5f; text-decoration: underline; }
    strong { color: #1d3531; }
    hr { border: 0; border-top: 1px solid #f0eef4; margin: 2rem 0; }

    // Tabela é a espinha destes documentos e costuma ser larga: rola dentro da
    // própria caixa em vez de empurrar a página para o lado.
    table {
      display: block;
      overflow-x: auto;
      width: 100%;
      border-collapse: collapse;
      margin: 0 0 1.5rem;
      font-size: 0.875rem;
    }

    th, td {
      border: 1px solid #ebe9f1;
      padding: 0.6rem 0.75rem;
      text-align: left;
      vertical-align: top;
    }

    th {
      background: #f8f8f8;
      color: #1d3531;
      font-weight: 600;
      white-space: nowrap;
    }
  }
}
</style>
